import { combineReducers } from 'redux';

import entitiesReducer from './entities';
import uiBrandsReducer from './ui/uiBrandsReducer';

export default combineReducers({
  entities: entitiesReducer,
  ui: uiBrandsReducer,
});
